import { RefObject } from "react";

import {
  ProductAssignmentListResponseType,
  ProductPriceTierDerivationType,
} from "@sellar-io/api-v2/types";

import { PriceListPricingMap } from "./priceListStore";

export type CustomPriceListInputProps = {
  productList: ProductAssignmentListResponseType;
  parent: ProductAssignmentListResponseType[number];
  product: ProductAssignmentListResponseType[number]["Products"][number];
  inputRefs: RefObject<Record<string, HTMLInputElement | null>>;
  price: string | undefined;
  productIndex: number;
  parentIndex: number;
  onUpdatePrice: (parameters: {
    productId: number;
    price: number | null;
  }) => void;
  setInputRef: (params: {
    productId: number;
    el: HTMLInputElement | null;
  }) => void;
};

export const derivationTypes: {
  type: ProductPriceTierDerivationType;
  display: string;
}[] = [
  {
    type: "none",
    display: "Do not apply",
  },
  {
    type: "custom",
    display: "Fixed",
  },
  {
    type: "inherit",
    display: "Inherit",
  },
  {
    type: "percentage",
    display: "% amount off",
  },
  {
    type: "flat",
    display: "£ amount off",
  },
];

export const generatePatchParameters = (
  priceListPricingMap: PriceListPricingMap,
  priceListId: number,
) => {
  return Object.entries(priceListPricingMap)
    .filter(([, { updated }]) => updated)
    .map(
      ([
        productId,
        {
          productPriceListId,
          derivationType,
          derivationValue,
          basePrice,
          price,
          discountable,
        },
      ]) => {
        if (productPriceListId) {
          if (price === null || price === undefined) {
            return {
              action: "DELETE" as const,
              id: productPriceListId,
            };
          }
          return {
            action: "PUT" as const,
            id: productPriceListId,
            value: {
              price: price,
              discountable: discountable,
              derivationType,
              derivationValue,
            },
          };
        } else {
          return {
            action: "POST" as const,
            value: {
              ProductId: Number(productId),
              PriceListId: priceListId,
              basePrice,
              price: price ?? 0,
              discountable: discountable,
              active: true,
            },
          };
        }
      },
    );
};
